import React from "react";
import { Button, ButtonGroup } from "convertupleads-theme";
import PreviewAndEditor from "../../../../../common/PreviewAndEditor";

const OutlinedButtonGroupVertical = () => {
  return (
    <>
      <PreviewAndEditor
        language="js"
        title={"Outlined vertical primary button group"}
        value={
          '<ButtonGroup variant={"outlined"} orientation="vertical" aria-label="outlined vertical primary button group">\n\t<Button>One</Button>\n\t<Button>Two</Button>\n\t<Button>Three</Button>\n</ButtonGroup>'
        }
      >
        <ButtonGroup
          variant={"outlined"}
          orientation="vertical"
          aria-label="outlined vertical primary button group"
        >
          <Button>One</Button>
          <Button>Two</Button>
          <Button>Three</Button>
        </ButtonGroup>
      </PreviewAndEditor>
    </>
  );
};

export default OutlinedButtonGroupVertical;
